import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeFormat'
})
export class TimeFormatPipe implements PipeTransform {

  transform(time: string, format: string = 'HH:mm'): string {
    if (!time) return '';

    // Split the time range into start and end times
    // const [startTime, endTime] = time.split('-');

    // Function to convert 24-hour format to 12-hour format with AM/PM
    const convertTo12HourFormat = (time: string): string => {
        const [hours, minutes] = time.split(':').map(Number);
        let period = 'am';
        let hour = hours;

        if (hours >= 12) {
            period = 'pm';
            if (hours > 12) {
                hour = hours - 12;
            }
        }

        if (hour === 0) {
            hour = 12; // 0 hour is 12 in 12-hour format
        }

        return format=='HH:mm'?`${hour}:${minutes}`:`${hour}:${minutes}${period}`;
    };

    // Convert start and end times
    const convertedTime = convertTo12HourFormat(time.trim());

    return convertedTime;
}

}
